import createReducer from 'utils/createReducer';

// Initial State
const INIT_STATE = {
  mainLoading: false,
  submiting: false,
  quote: {
    ready: false,
    loading: false,
  },
};

// Actions
const SET_MAIN_LOADING = 'journey-edit/SET_MAIN_LOADING';
const SET_QUOTE = 'journey-edit/SET_QUOTE';
const SET_QUOTE_READY = 'journey-edit/SET_QUOTE_READY';
const SET_QUOTE_LOADING = 'journey-edit/SET_QUOTE_LOADING';
const SET_SUBMITING = 'journey-edit/SET_SUBMITING';
const SET_RESET = 'journey-edit/SET_RESET';

// Reducers
export default createReducer(INIT_STATE, {
  [SET_MAIN_LOADING](state, payload) {
    return {
      ...state,
      mainLoading: payload,
    };
  },
  [SET_QUOTE](state, payload) {
    return {
      ...state,
      quote: {
        ...state.quote,
        ...payload,
      },
    };
  },
  [SET_QUOTE_LOADING](state, payload) {
    return {
      ...state,
      quote: {
        ...state.quote,
        loading: payload,
      },
    };
  },
  [SET_QUOTE_READY](state, payload) {
    return {
      ...state,
      quote: {
        ...state.quote,
        ready: payload,
      },
    };
  },
  [SET_SUBMITING](state, payload) {
    return {
      ...state,
      submiting: payload,
    };
  },
  [SET_RESET](state, payload) {
    const { quote } = INIT_STATE;
    return {
      ...state,
      quote,
    };
  },
});

export const setMainLoading = (payload) => ({
  type: SET_MAIN_LOADING,
  payload: payload,
});

export const setQuote = (payload) => ({
  type: SET_QUOTE,
  payload: payload,
});

export const setQuoteLoading = (payload) => ({
  type: SET_QUOTE_LOADING,
  payload: payload,
});

export const setQuoteReady = (payload) => ({
  type: SET_QUOTE_READY,
  payload: payload,
});

export const setSubmiting = (payload) => ({
  type: SET_SUBMITING,
  payload: payload,
});

export const setReset = (payload) => ({
  type: SET_RESET,
  payload: payload,
});
